'use strict';

(function (global) {

  // Css-классы
  const baseCssClass = 'preview-container';
  const iframeCssClassHidden = `${baseCssClass}__content_hidden`;
  const overlayCssClass = `${baseCssClass}__overlay`;
  const overlayCssClassHidden = `${overlayCssClass}_hidden`;

  // Селекторы
  const iframeSelector = '#contentContainer';
  const overlaySelector = `.${overlayCssClass}`;

  /**
   * Предпросмотр документа.
   *
   * @hideconstructor
   * @since 5.7.0
   */
  class Preview {

    /**
     * Проинициализировать предпросмотр
     *
     * @method init
     * @param {object} context Модель данных предпросмотра, приходящая с сервера.
     */
    init(context) {
      this.context = context;

      this._jContainer = $(`#${context.wrapperId}`);
      this._jFrame = $(iframeSelector);

      this._urlHandler = context.previewHandlerUrl;

      const documentData = context.convertedObj;

      const dataType = new window.Core.preview.DataType(
        context.objectsData[context.selectedObj.id].dataType,
        documentData.isImage,
        documentData.pageCount
      );

      this.document = {
        convertedObjId: documentData.id,
        dataType: dataType,
        pageCount: documentData.pageCount,
        pageNumber: 1,
        versionId: context.versionsId,
      };

      this._documentHeadFile = {
        css: documentData.cssLink,
        js: documentData.scriptFileName,
      };

      this._jFrame.on('load', () => this._onFrameLoad());

      window.Core.preview.toolbar.init();
      this._setToolbarControlsVisibility();

      if (context.errorMessage) {
        this.showError(context.errorMessage, context.errorType);
        // Прячем блок, экранирующий область предпросмотра (тулбар предпросмотра и iframe с загруженным документом)
        this._hideOverlay();
      } else {
        this._loadFrame();
      }

      $(window).bind('resize', 'orientationchange', () => {
        if (window.Core.preview.actions) {
          window.Core.preview.actions.onResize();
        }
      });
    }

    /**
     * Загрузить версию документа для предпросмотра
     *
     * @method setVersion
     * @param {string} versionId Идентификатор версии.
     */
    setVersion(versionId) {
      this._showOverlay();
      const url = new WA.URL();
      const pluginName = (url.getParam('plugin')) ? url.getParam('plugin').toLowerCase() : url.getParam('convertPlugin').toLowerCase();

      $.ajax({
        type: 'GET',
        url: this._urlHandler,
        data: {
          id: versionId,
          plugin: pluginName,
        },
        cache: false,
        dataType: 'json',

        success: (data) => {
          this.hideError();

          const dataType = new window.Core.preview.DataType(
            this.context.objectsData[versionId].dataType,
            data.IsImage,
            data.PageCount
          );

          this.document = {
            convertedObjId: data.Id,
            dataType: dataType,
            pageCount: data.PageCount,
            pageNumber: 1,
            versionId: versionId,
          };

          // TODO: в будущем хорошо бы отказаться от объекта context в таком виде
          const context = window.Core.preview.context;
          context.convertedObj.pageCount = this.document.pageCount;
          context.convertedObj.id = this.document.convertedObjId;
          context.selectedObj.id = this.document.versionId;

          this._setToolbarControlsVisibility();
          Core.preview.toolbar.initScaleInputValues();

          this._loadFrame();
        },

        error: (response) => {
          const msg = JSON.parse(response.responseText);
          this.showError(msg.error, msg.errorType);

          this._hideOverlay();
        }

      });
    }

    /**
     * Загрузить документ в iframe
     *
     * @method _loadFrame
     * @private
     */
    _loadFrame() {
      const frameSrc = `${this._urlHandler}/${this.document.convertedObjId}/1`;
      this._jFrame
        .attr('src', frameSrc)
        .addClass(iframeCssClassHidden);
    }

    /**
     * Преобразовать документ после его загрузки в iframe
     *
     * @method _prepareFreshlyLoadedDocument
     * @private
     * @return {Promise<void>}
     */
    _prepareFreshlyLoadedDocument() {
      let postprocessor;
      const docType = this.document.dataType;
      if (docType.isText) {
        if (docType.wasMadeFromMsWordDocument) {
          postprocessor = window.Core.preview.WordDocumentPostprocessor;
        } else {
          postprocessor = window.Core.preview.BaseDocumentPostprocessor;
        }
      } else if (docType.isSpreadsheet) {
        postprocessor = window.Core.preview.ExcelDocumentPostprocessor;
      } else {
        if (docType.isMultipage) {
          postprocessor = window.Core.preview.MultipageDocumentPostprocessor;
        } else {
          postprocessor = window.Core.preview.ImageDocumentPostprocessor;
        }
      }

      return postprocessor.prepare(this._jFrame, this._documentHeadFile, this.document.dataType._extension);
    }

    /**
     * Устанавливает необходимые действия в зависимости от типа документа
     *
     * @method _getAppropriatePreviewActions
     * @private
     * @return {class} Класс действий предпросмотра, наследуемый от window.Core.preview.BaseActions
     */
    _getAppropriatePreviewActions() {
      const docType = this.document.dataType;
      if (docType.isText) {
        if (docType.wasMadeFromMsWordDocument) {
          return new window.Core.preview.WordDocumentActions(this.context);
        } else {
          return new window.Core.preview.TextActions(this.context);
        }

      } else if (docType.isSpreadsheet) {
        return new window.Core.preview.SpreadsheetActions(this.context);

      } else {
        // TODO: Создать отдельные actions для многостраничных документов
        if (docType.isMultipage) {
          return new window.Core.preview.MultipageActions(this.context);
        } else {
          return new window.Core.preview.ImageActions(this.context);
        }
      }
    }

    /**
     * Скрыть или показать контролы тулбара предпросмотра в зависимости от типа документа
     *
     * @method _setToolbarControlsVisibility
     * @private
     */
    _setToolbarControlsVisibility() {
      const docType = this.document.dataType;
      const toolbar = window.Core.preview.toolbar;
      const toolbarControls = toolbar.controls;

      if (docType.isImage || docType.isScalable) {
        toolbarControls.fitToButtons.show();
        toolbarControls.scale.show();
        toolbarControls.rotateButtons.show();
      } else {
        toolbarControls.fitToButtons.hide();
        toolbarControls.scale.hide();
        toolbarControls.rotateButtons.hide();
      }

      if (docType.isText) {
        toolbarControls.fitToButtons.hide();
        toolbarControls.rotateButtons.hide();
      }

      if (docType.isMultipage) {
        toolbarControls.pagination.show();
        toolbar.updatePaginator(this.document.pageCount);
      } else {
        toolbarControls.pagination.hide();
      }

      if (docType.wasMadeFromMsWordDocument) {
        toolbarControls.wordButtons.show();
      } else {
        toolbarControls.wordButtons.hide();
      }
    }

    /**
     * Произвести действия над предпросмотром после его загрузки в iframe
     *
     * @method _onFrameLoad
     * @private
     */
    _onFrameLoad() {
      this._prepareFreshlyLoadedDocument().then(() => {
        this._setToolbarControlsVisibility();

        window.Core.preview.actions = this._getAppropriatePreviewActions();
        window.Core.preview.actions.setScale();

        if (this.document.dataType.isMultipage) {
          window.Core.preview.actions.loadNeighbors(1);
        } else if (this.document.dataType.isText && this.document.dataType.wasMadeFromMsWordDocument) {
          const toolbarButtons = window.Core.preview.toolbar.buttons;
          toolbarButtons.enableChangeTrack.setSelectedStateAndPerformAction(window.Core.preview.actions.settings.trackChangesVisibility);
          toolbarButtons.enableComments.setSelectedStateAndPerformAction(window.Core.preview.actions.settings.commentsVisibility);
        }

        // Показываем iframe (с сервера он пришёл к нам спрятанным, чтобы у пользователя не мелькало масштабирование)
        this._jFrame.removeClass(iframeCssClassHidden);

        // Прячем блок, экранирующий область предпросмотра (тулбар предпросмотра и iframe с загруженным документом)
        this._hideOverlay();

        //Вызываем во фрейме событие окончания отображения предпросмотра
        var event = document.createEvent('CustomEvent');
        event.initCustomEvent('start', false, false, this._jFrame[0]);
        this._jFrame[0].dispatchEvent(event);
      });
    }

    /**
     * Отобразить блок, экранирующий область предпросмотра.
     * Используется во время загрузки содержимого предпросмотра, чтобы пользователь не трогал контролы раньше времени.
     *
     * @method _showOverlay
     * @private
     */
    _showOverlay() {
      const jOverlay = this._jContainer.find(overlaySelector);
      jOverlay.removeClass(overlayCssClassHidden);
    }

    /**
     * Спрятать блок, экранирующий область предпросмотра.
     *
     * @method _hideOverlay
     * @private
     */
    _hideOverlay() {
      const jOverlay = this._jContainer.find(overlaySelector);
      jOverlay.addClass(overlayCssClassHidden);
    }

    /**
     * Показать сообщение об ошибке.
     *
     * @method showError
     * @param {string} errorMsg Сообщение об ошибке.
     * @param {string} errorType Тип сообщения (ошибка/предупреждение).
     */
    showError(errorMsg, errorType) {
      $.when(WA.FormControlsInit).then(() => {
        WA.CMP.NTF.InlineHint.hideAll();
        const inlineHintParams = {
          type: (errorType === 'error') ? MESSAGE_TYPE.ERROR : MESSAGE_TYPE.WARNING,
          priority: INLINE_HINT_PRIORITY.PRIMARY,
        };
        WA.CR.inlineHint.show(errorMsg, inlineHintParams);
      });
    }

    /**
     * Спрятать сообщения об ошибке.
     *
     * @method hideError
     */
    hideError() {
      $.when(WA.FormControlsInit).then(() => {
        WA.CR.inlineHint.hide();
      });
    }

  }

  global.preview = new Preview();

})(window.Core);
